import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";

/** Skeleton component to display in the projects map */
export function ProjectsMapSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton variant="rectangular" sx={{
      width: "100%",
      height: "100%"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}